import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const updateForumThread = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.FORUM_AREA.UPDATE_FORUM_THREAD,
    data
  );
};

export default updateForumThread;
